import { useModalOutlet as f, DefaultModalOutlet as _ } from "./useModalOutlet.js";
import { createResolver as p } from "../../../utils/resolver.js";
async function y(s, t, i = {}) {
  let o;
  const { containerId: n = _, e: a } = i, e = f(n);
  typeof t == "function" ? (e.isPending.value = !0, o = await t(), e.isPending.value = !1) : o = t;
  const { promise: l, resolve: u, reject: c } = p(), r = {
    component: s,
    containerId: n,
    props: o,
    onResolve: u,
    onReject: c,
    e: a,
    id: m++
  };
  return e.push(r), l.finally(() => {
    e.dispose(r);
  }), l.then((d) => d);
}
let m = 0;
export {
  y as useModal
};
